module.exports = __webpack_public_path__ + "img/plus-colorless.bf3e5b2f.svg";